var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComboBottomTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M18 24H2C1.45 24 1 23.55 1 23V14.5C1 12.845 2.345 11.5 4 11.5H16C17.655 11.5 19 12.845 19 14.5V23C19 23.55 18.55 24 18 24Z",
    fill: "#D0D7DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M11.75 15.75H5.25C4.835 15.75 4.5 15.415 4.5 15C4.5 14.585 4.835 14.25 5.25 14.25H11.75C12.165 14.25 12.5 14.585 12.5 15C12.5 15.415 12.165 15.75 11.75 15.75Z",
    fill: "#AFB8C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M14.75 19H5.25C4.835 19 4.5 18.665 4.5 18.25C4.5 17.835 4.835 17.5 5.25 17.5H14.75C15.165 17.5 15.5 17.835 15.5 18.25C15.5 18.665 15.165 19 14.75 19Z",
    fill: "#AFB8C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M1.05 0.290098L8.6 3.5701C8.24 3.9251 8.015 4.4101 8 4.9501L0.450001 1.6651C0.175001 1.5451 0 1.2751 0 0.980098C0 0.550098 0.355 0.225098 0.75 0.225098C0.85 0.225098 0.949999 0.245098 1.05 0.290098Z",
    fill: "#D0D7DE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M20.0004 0.979936C20.0004 1.27494 19.8254 1.54494 19.5504 1.66494L12.0004 4.94994C11.9854 4.40994 11.7604 3.92494 11.4004 3.56994L18.9504 0.289936C19.4454 0.0749359 20.0004 0.439936 20.0004 0.979936Z",
    fill: "#D0D7DE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M12.25 10H7.75C7.335 10 7 9.665 7 9.25C7 8.835 7.335 8.5 7.75 8.5H12.25C12.665 8.5 13 8.835 13 9.25C13 9.665 12.665 10 12.25 10Z",
    fill: "#AFB8C1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M12 4.95V5C12 6.105 11.105 7 10 7C8.895 7 8 6.105 8 5V4.95C8.015 4.41 8.24 3.925 8.6 3.57C8.965 3.22 9.455 3 10 3C10.545 3 11.035 3.22 11.4 3.57C11.76 3.925 11.985 4.41 12 4.95Z",
    fill: "#AFB8C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComboBottomTop);
export default __webpack_public_path__ + "static/media/combo-bottom-top.76856e3bbbb6bbc3e9ffae830a2a4fd8.svg";
export { ForwardRef as ReactComponent };